
export default class {

    static render(icon)
    {
        return `<div class="iconService">
                    <img title="${icon}" src="/wp-content/themes/dt-the7-child/assets/icons/mapicons/${icon}.png">
                </div>`;

    }
}
